<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" id="info-edit">
  <g fill="currentColor" fill-rule="evenodd">
    <circle stroke="currentColor" stroke-width=".5" cx="7.273" cy="7.273" r="7.023"/>
    <path d="M8 10.727v-4c0-.1-.081-.182-.182-.182h-1.09c-.101 0-.183.082-.183.182v4c0 .1.082.182.182.182h1.091c.1 0 .182-.081.182-.182zM6.545 4.364a.724.724 0 00.438.67.718.718 0 00.29.057c.102 0 .197-.02.285-.058a.753.753 0 00.231-.155A.705.705 0 008 4.364a.74.74 0 00-.21-.52.723.723 0 00-.517-.208.742.742 0 00-.29.056.7.7 0 00-.382.385.74.74 0 00-.056.287z" fill="#ffffff" fill-rule="nonzero"/>
  </g>
</svg>
